import { fr } from "@codegouvfr/react-dsfr"
import { Typography } from "@mui/material"
import type { ILbaItemFormation2Json, ILbaItemFtJobJson, ILbaItemLbaCompanyJson, ILbaItemLbaJobJson } from "shared"
import { DsfrLink } from "@/components/dsfr/DsfrLink"
import { getPathLink } from "@/utils/tools"
import ItemDistanceToCenter from "./ItemDistanceToCenter"

export default function ItemLocalisation({ item }: { item: ILbaItemFormation2Json | ILbaItemLbaCompanyJson | ILbaItemLbaJobJson | ILbaItemFtJobJson }) {
  return (
    <Typography sx={{ my: fr.spacing("4v") }}>
      <Typography component="span" sx={{ fontWeight: 700 }}>
        Localisation :{" "}
      </Typography>
      <Typography component="span">
        <DsfrLink href={getPathLink(item)}>
          {item?.place?.fullAddress}
          <span className="fr-sr-only"> - localisation sur Google Maps</span>
        </DsfrLink>
      </Typography>
      <br />
      <ItemDistanceToCenter item={item} />
    </Typography>
  )
}
